import React from 'react';
import { Document, Page, Text, Image, StyleSheet, Font, View } from '@react-pdf/renderer';
import logo from '../../assets/images/login-logo.png';

const RedemptionHistoryPDF = ({ data }) => (
    <Document>
        <Page style={styles.body}>
            {/* Centered Logo */}
            <View style={styles.logoContainer}>
                <Image style={styles.logoLarge} src={logo} />
            </View>
            {/* Exclusive offer text */}
            <View style={styles.exclusiveContainer}>
                <Text style={styles.exclusiveText}>Exclusive offer for {data?.commuter?.name ? `the ${data.commuter.name}` : 'you'}</Text>
            </View>
            {/* Card-like info section */}
            <View style={styles.card}>
                <View style={styles.row}>
                    <View style={styles.labelCol}>
                        <Text style={styles.label}>Reward:</Text>
                    </View>
                    <View style={styles.valueCol}>
                        <Text style={styles.value}>{data?.offer?.name || 'N/A'}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.labelCol}>
                        <Text style={styles.label}>Redeem:</Text>
                    </View>
                    <View style={styles.valueCol}>
                        <Text style={styles.value}>{data?.redemptionValue || 'N/A'}</Text>
                    </View>
                </View>
                <View style={styles.row}>
                    <View style={styles.labelCol}>
                        <Text style={styles.label}>Redemption Date:</Text>
                    </View>
                    <View style={styles.valueCol}>
                        <Text style={styles.value}>
                            {data?.redeemedAt
                                ? new Date(data?.redeemedAt).toLocaleString()
                                : data?.addedToWalletAt
                                ? new Date(data?.addedToWalletAt).toLocaleString()
                                : 'N/A'}
                        </Text>
                    </View>
                </View>
                {/* Branches section */}
                {Array.isArray(data?.branches) && data.branches.length > 0 && (
                    <View style={styles.row}>
                        <View style={styles.labelCol}>
                            <Text style={styles.label}>Branches:</Text>
                        </View>
                        <View style={styles.valueCol}>
                            <Text style={styles.value}>{data.branches.map((b, idx) => `${b.name}${b.address ? ' (' + b.address + ')' : ''}`).join(', ')}</Text>
                        </View>
                    </View>
                )}
                {/* Redeemed Branch section */}
                <View style={styles.row}>
                    <View style={styles.labelCol}>
                        <Text style={styles.label}>Redeemed Branch:</Text>
                    </View>
                    <View style={styles.valueCol}>
                        <Text style={styles.value}>
                            {data?.redeemedBranch?.name
                                ? `${data.redeemedBranch.name}${data.redeemedBranch.address ? ' (' + data.redeemedBranch.address + ')' : ''}`
                                : 'N/A'}
                        </Text>
                    </View>
                </View>
                {/* Horizontal line */}
                <View style={styles.hr} />
                {/* Centered, larger QR code */}
                <View style={styles.qrCodeContainer}>
                    {data?.qrCode ? <Image style={styles.qrImageXLarge} src={data.qrCode} /> : <Text style={styles.value}>N/A</Text>}
                </View>
            </View>
        </Page>
    </Document>
);

Font.register({
    family: 'Oswald',
    src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

const styles = StyleSheet.create({
    body: {
        paddingTop: 25,
        paddingBottom: 40,
        paddingHorizontal: 35,
        backgroundColor: '#f7f7f7'
    },
    logoContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 16,
        marginTop: 10
    },
    logoLarge: {
        width: 100,
        height: 100,
        marginBottom: 8
    },
    exclusiveContainer: {
        alignItems: 'center',
        marginBottom: 18
    },
    exclusiveText: {
        fontSize: 16,
        fontFamily: 'Oswald',
        color: '#13aa61',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    card: {
        backgroundColor: '#fff',
        borderRadius: 10,
        padding: 24,
        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
        marginHorizontal: 10,
        marginTop: 10
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 12
    },
    labelCol: {
        width: 140
    },
    valueCol: {
        flex: 1
    },
    label: {
        fontSize: 13,
        fontFamily: 'Oswald',
        color: '#333',
        fontWeight: 'bold'
    },
    value: {
        fontSize: 13,
        fontFamily: 'Oswald',
        color: '#505050'
    },
    hr: {
        borderBottomWidth: 1,
        borderBottomColor: '#eee',
        marginVertical: 18,
        width: '100%'
    },
    qrCodeContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 18,
        marginBottom: 10
    },
    qrImageXLarge: {
        width: 200,
        height: 200,
        border: '1px solid #eee',
        borderRadius: 10
    }
});

export default RedemptionHistoryPDF;
